import {GetStaticPropsContext} from "next/types";
import {getServerSideProps as getLocaleProps} from "@/base/utils/localalization";
import {FetchPage} from "@/base/pages/p/[...slug]";
import Layout from "@/components/layout/main";
import MetaBlock from "@/base/components/MetaBlock";
import BlogTop from "@/components/blog/BlogTop";
import View from "@/components/blog/View";
import {CustomPage} from "@/base/types/CustomPage";
import React from "react";
import {useTranslation} from "next-i18next";
import {getRegionConfig} from "@/base/utils/regions";


export const getServerSideProps = async (ctx: GetStaticPropsContext) => {
	const slug = (ctx?.params?.slug as string[] || []).join('/');
	//todo move pl to env
	const page: any | null = await FetchPage(slug, ctx.locale || 'en', 'pl');
	let color = '#FFFFFF';
	if (!page)
	{
		// Page not found, redirect to a predefined not-found page or any other existing page
		return {
			redirect: {
				destination: '/not-found', // Replace this with your desired destination
				permanent: false,
			},
		};
	}
	if (page && page.palette && page.palette.length > 0)
	{
		color = page.palette[0].hex ? page.palette[0].hex : '#FFFFFF';
	}

	const output = (await getLocaleProps(ctx, ['base-common', 'blog', 'landing-pl']));
	output.props = {
		...output.props || {},
		page: {
			slug: slug,
			output: page,
			color
		},
		notFound: true
	} as any;

	return {
		...output
	};
}

type Props = {
	page: {
		slug: string,
		output: CustomPage | null,
		color: string
	}
};
export default function Page(props: Props) {
	const {t} = useTranslation();
	const regionConfig = getRegionConfig();

	return (<>
			<MetaBlock
				title={props.page?.output?.title || t('base-landing:meta.title-page')}
				description={props.page?.output?.description || t('base-landing:meta.description-page', {
					in: t(regionConfig.tKey('in'))
				})}
			/>
			<div className={`overflow-hidden mt-[-120px]`}>
				<div className={`container `}>
					<BlogTop title={props.page?.output?.title || ""} published={props.page.output?.updated_at || ""} readingTime={10} image={props.page.output?.image_url} color={props.page.color}/>
				</div>
			</div>
			<View content={props.page.output}/>
		</>
	);
}

Page.getLayout = function getLayout(page: any) {
	return (
		<Layout>
			{page}
		</Layout>
	);
};